import { render } from "./Item3.vue?vue&type=template&id=4c89ace2"
import script from "./Item3.vue?vue&type=script&lang=ts"
export * from "./Item3.vue?vue&type=script&lang=ts"
script.render = render

export default script